import React from 'react';
import wordpress from '../../assets/logo/wordpress.png';
import divi from '../../assets/logo/divi.png';
import elementor from '../../assets/logo/elementor.png';
import wix from '../../assets/logo/wix.png';
import shopify from '../../assets/logo/shopify.png';
import seo from '../../assets/logo/seo.png';
import cpanel from '../../assets/logo/cpanel.png';
import ftp from '../../assets/logo/ftp.png';

const OtherSkills = () => {
    return (
        <div data-aos="fade-up" data-aos-duration="2000">
            <div className="flex items-center mt-20 mb-4">
                <span className="h-0.5 bg-accent w-24"></span>
                <p className="ml-3">Other skills & tools</p>
            </div>
            {/* -----------all other skills section----------- */}
            <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-3">
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={wordpress} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">WordPress</h2>
                            <p>My progress in WordPress</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={divi} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Divi Builder</h2>
                            <p>My progress in Divi Builder</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={elementor} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Elementor</h2>
                            <p>My progress in Elementor</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={wix} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Wix</h2>
                            <p>My progress in Wix</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={shopify} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">shopify</h2>
                            <p>My progress in shopify</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="90"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={cpanel} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">Control Panel</h2>
                            <p>My progress in cPanel</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="60"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={ftp} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">FTP</h2>
                            <p>My progress in FTP</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="50"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
                {/* ----------single card----------- */}
                <div id="experience" className="card glass rounded-sm">
                    <div className="flex items-center">
                        <figure className="p-2">
                            <img src={seo} alt="" />
                        </figure>
                        <div className="p-2">
                            <h2 className="card-title">SEO</h2>
                            <p>My progress in SEO</p>
                            <progress
                                className="progress progress-accent w-56"
                                value="95"
                                max="100"
                            ></progress>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtherSkills;
